import script from "./TrendingCoins.vue?vue&type=script&setup=true&lang=js"
export * from "./TrendingCoins.vue?vue&type=script&setup=true&lang=js"

import "./TrendingCoins.vue?vue&type=style&index=0&id=b66bb332&lang=scss"

const __exports__ = script;

export default __exports__